<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <div class="p-3">
            <img src="@/assets/grid/jugendliche.webp"
                class="w-full aspect-video max-h-[500px] object-cover rounded-md shadow-md">
        </div>
        <div class="flex flex-col md:flex-row pt-12 md:pt-24 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Jugendarbeit statt Konfirmandenstunde</h1>
                    <p class="text-lg text-gray-500 mt-3">Wie geht's weiter?</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Jugendgruppe „churchy nerds“ in Rastenberg. Jugendliche zwischen 12 und 18 Jahren treffen sich
                        in regelmäßigen Abständen zu gemeinsam geplanten Vorhaben, zum Wandern, Feiern, Essen und
                        Trinken, Themen, Singen, Spielen etc. Auch wer sich konfirmieren lassen will, sollte zu diesen
                        Treffen dazu kommen.
                        <br>
                        <br>
                        Vor einigen Jahren wurdest Du durch die Taufe in der Kirchengemeinde begrüßt. Seitdem ist Zeit
                        vergangen. Vielleicht hast Du die Gelegenheit gehabt, an Veranstaltungen der kirchlichen Arbeit
                        mit Kindern teilzunehmen. Vielleicht hast Du die Christenlehre oder die Pfadfindergruppe besucht
                        oder ein Krippenspiel mitgestaltet. Vielleicht besuchst Du den Religionsunterricht oder Du hast
                        auch mal an einer christlichen Freizeitfahrt teilgenommen.
                        <br>
                        Den Christinnen und Christen in deinem Ort ist es wichtig, dass du dich in deiner
                        Kirchengemeinde wohlfühlst. Das schönste Ziel wäre, dass du dich selbst als Teil der
                        Gemeinschaft in der Kirche siehst. Traditionell gab es in den Kirchengemeinden in der 7. und 8.
                        Klasse Konfirmandenstunden, die mit Vorstellungsgottesdienst und Konfirmation abschlossen. Das
                        Angebot war für viele Jugendliche toll, besonders das Zusammensein der Jugendlichen hat Spaß
                        gemacht. Aber nach der Konfirmation war dann auch für fast alle Schluss mit Kirche.
                        Deshalb starten wir ein neues Projekt.
                        <br>
                        Ab sofort sind alle Jugendlichen zwischen 12 und 18 Jahren zu monatlichen Treffen eingeladen.
                        Die Termine machen wir uns immer miteinander aus. Auch was wir miteinander unternehmen möchten
                        planen wir gemeinsam. Und selbstverständlich kann auch jeder, der das möchte, konfirmiert
                        werden, mit dem Unterschied, dass das die Jugendlichen selbst entscheidet. Und ihr könnt euch
                        auch mit 15 oder 16 Jahren konfirmieren lassen. Dazu gibt es dann eine eigene Vorbereitung. Aber
                        grundsätzlich gilt, alle können dabei sein, auch nicht Getaufte oder nicht Konfirmierte. Das ist
                        eben nicht das Entscheidende, sondern dass ihr hier etwas erlebt, was euch bereichert. Und ihr
                        entscheidet selbst, welche Rolle der Glaube in eurem Leben spielen soll. Wir machen uns mit euch
                        auf Entdeckungsreise.
                    </p>
                </div>
            </div>
            <GridNav />
        </div>
    </div>
</template>

<script>
import GridNav from '@/components/gridNav.vue'

export default {
    name: 'Jugendliche',
    data() {
        return {
        }
    },
    components: {
        GridNav
    }
}
</script>